import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, flushAnalyticsQueue } from "../lib/analytics";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    flushAnalyticsQueue();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Track every SPA navigation as a pageview for admin analytics
    const title = document.title || pathname;
    trackPageView(`${pathname}${search || ""}`, title);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
